import { render, staticRenderFns } from "./wallet-info.vue?vue&type=template&id=4161f88e&"
import script from "./wallet-info.vue?vue&type=script&lang=js&"
export * from "./wallet-info.vue?vue&type=script&lang=js&"
import style0 from "./wallet-info.vue?vue&type=style&index=0&id=4161f88e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports